import { render, staticRenderFns } from "./GdprCookiePolicyBanner.vue?vue&type=template&id=5576f1da&scoped=true"
import script from "./GdprCookiePolicyBanner.vue?vue&type=script&lang=js"
export * from "./GdprCookiePolicyBanner.vue?vue&type=script&lang=js"
import style0 from "./GdprCookiePolicyBanner.vue?vue&type=style&index=0&id=5576f1da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5576f1da",
  null
  
)

export default component.exports